export default function () {
  this.loadReport()
}
